import React, {useEffect} from 'react'
import Topbar from '../../components/topbar/Topbar'
import { useHistory } from 'react-router'
import {activateMemberAccount} from '../../actions'
import {useDispatch, useSelector} from 'react-redux'
 
const {REACT_APP_D_CORE_URL} = process.env;
const AppUrl = REACT_APP_D_CORE_URL


const ActivateMemberAccount = ()=>{

    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector((state)=>{
        const {validateMemberAccount} = state
        const {status} = validateMemberAccount
        return{
            status
        }
    })

    const params = new URLSearchParams(window.location.search)
    const otp = params.get('otp')

    useEffect(()=>{
        if(otp){
            dispatch(activateMemberAccount(otp))
        }else{
            dispatch(activateMemberAccount(123))
        }
        console.log(apiResponse.status);
    },[])

    return(
        <div className="email-validation-container">
            <Topbar hasName={true}/>
            <div className="email-validation-header">
            </div>
            <div className="email-validation-card" style={{padding: '20px'}}>
                <span>{apiResponse.status}</span>
                <p></p>
                <button 
                    onClick={()=>window.open(`${AppUrl}`)}
                    >LOGIN</button>
            </div>
        </div>
    )

}
export default ActivateMemberAccount